import { CityLedgerSearchResult, useRepositoryQuery } from '@mews-commander/data-access';

export const useInvoiceSearch = (selectedInvoices: string[]) => {
    const useSearchQuery = (searchToken: string) =>
        useRepositoryQuery(
            'cityLedger',
            'search',
            {
                searchToken,
            },
            { select: (data) => removeSelectedFromSearch(data, selectedInvoices) }
        );

    return useSearchQuery;
};

const removeSelectedFromSearch = (data: CityLedgerSearchResult, selectedInvoices: string[]) => {
    return { invoices: data.invoices.filter((invoice) => !selectedInvoices.includes(invoice.invoiceId)) };
};
